




import {Vue, Component} from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    AdminIframe
  }
})
export default class EditGroupManagementCodeIframe extends Vue {
  private get remoteSrc() {
    const queryObject = { 
      mallNo: this.$route.query.mallNo.toString(),
      productNos: this.$route.query.productsNos.toString(),
      serviceType: 'PREMIUM'
    };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/group-management-code' + '?' + queryString;

    return src;
  }

  private receiveMessage(e: MessageEvent) {
    if (e.data.result === 'SUCCESS') {
      window.opener.postMessage({successChangeGroupManagementCode: true});
      window.close();
    }
  }

  mounted() {
    window.addEventListener('message', this.receiveMessage);
  }

  beforeUnmount() {
    window.removeEventListener('message', this.receiveMessage);
  }
}
